import { useReactiveVar } from "@apollo/client";
import { Dialog } from "@dmm-com/rocket-web-ui-library";
import { memo, useCallback, useEffect } from "react";
import { closeDialog, dialogState } from "~/components/stores/dialog/store";
import { Z_INDEX } from "~/styles/z-index";

export const DialogStore = memo(() => {
  const state = useReactiveVar(dialogState);

  const closeDialogWhenUnmount = () => {
    if (state.isVisible) closeDialog();
  };

  useEffect(() => {
    window.addEventListener("popstate", closeDialogWhenUnmount, { passive: true });
    return () => {
      closeDialogWhenUnmount();
      window.removeEventListener("popstate", closeDialogWhenUnmount);
    };
  }, [state.isVisible]);

  const onCloseDialog = useCallback(() => {
    if (state.onCloseDialogCallback) state.onCloseDialogCallback();

    closeDialog();
  }, [state.onCloseDialogCallback]);

  return <Dialog {...state} onCloseDialog={onCloseDialog} zIndex={Z_INDEX.DIALOG} />;
});

DialogStore.displayName = "DialogStore";
